export const USER = 'diversity-bbva-trivia-user'

export const PROXY = process.env.REACT_APP_PROXY

export const TIMER = 10 // seconds
export const TIMER_DELAY = 1000
export const TIMER_SUCCESS = '#48ae64'
export const TIMER_FAILED = '#b13d47'
export const TIMER_TICKING = '#fcd13e'

export const GOOGLE_ANALYTICS = 'UA-119335583-1'
export const LANGUAGES = ['es', 'en']
export const I18N = {
  es: 'es',
  en: 'en-gb'
}



// WEBPACK FOOTER //
// ./src/config/index.js